export const formatName = (name) => {

  if (!name || name === '' || name == null) {  
    return { shortname: 'N/A', initials: 'N/A', lastName: 'N/A' };
  }

  // Split name by spaces and filter out any empty strings
  const nameParts = name.split(' ').filter(part => part.trim() !== '');

  // Handle case where nameParts is empty after filtering
  if (nameParts.length === 0) {
    return { shortname: 'N/A', initials: 'N/A', lastName: 'N/A' };
  }

  const lastName = nameParts.pop(); // Get last name
  const initials = nameParts.map(n => n[0].toUpperCase()).join('.'); // Get initials from first letters

  const fullName = {
    shortname: `${initials} ${lastName}`,
    initials: initials,
    lastName: lastName
  };
  return fullName;
};

